<template>
  <div class="social-share-buttons">
    <component
      v-for="social in enabledSocials"
      :key="`share-${social}`"
      :is="getSocialButtonComponent(social)"
      class="social-share-buttons__item"
      @share="handleShare"
    ></component>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../utils/gogocodeTransfer'
import TelegramShareButton from '@vue-app/components/base/share/buttons/TelegramShareButton.vue'
import WhatsAppShareButton from '@vue-app/components/base/share/buttons/WhatsAppShareButton.vue'
import ViberShareButton from '@vue-app/components/base/share/buttons/ViberShareButton.vue'
import { ShareService } from '@js-app/services/share/share-service'
import EmailShareButton from '@vue-app/components/base/share/buttons/EmailShareButton.vue'
import SmsShareButton from '@vue-app/components/base/share/buttons/SmsShareButton.vue'

export default {
  name: 'SocialShareButtons',
  components: {
    TelegramShareButton,
    ViberShareButton,
    WhatsAppShareButton,
  },
  props: {
    enabledSocials: {
      type: Array,
      default() {
        return ['telegram', 'whatsapp', 'viber']
      },
    },
    urlToShare: {
      type: String,
      default: null,
    },
    contentToShare: {
      type: String,
      default: '',
    },
  },
  methods: {
    getSocialButtonComponent(social) {
      switch (social) {
        case 'telegram':
          return TelegramShareButton
        case 'whatsapp':
          return WhatsAppShareButton
        case 'viber':
          return ViberShareButton
        case 'email':
          return EmailShareButton
        case 'sms':
          return SmsShareButton
      }
    },
    handleShare(provider) {
      const response = ShareService.share(
        provider,
        this.urlToShare,
        this.contentToShare
      )

      if (response?.needAction) {
        $emit(this, 'needAction', response.action)
      }
    },
  },
  emits: ['needAction'],
}
</script>

<style lang="scss" scoped>
.social-share-buttons {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
